// The settled balance remains the ledger total. A reservation is pending
// spend, not a charge; only the spendable snapshot is available for new work.
export function availableCredits(credits) {
  if (credits?.business) return credits.totalAvailable;
  if (Number.isFinite(credits?.reservedCredits) && Number.isFinite(credits?.totalAvailable)) {
    return Math.max(0, credits.totalAvailable - credits.reservedCredits);
  }
  return Number.isFinite(credits?.spendableAvailable) ? credits.spendableAvailable : credits?.totalAvailable;
}
